import { apiClient } from "@/services/apiClient";

export interface ClientCatalogItem {
  id: string;
  clientId: string;
  sku?: string;
  description: string;
  unitPrice: number;
  defaultTaxCategory: string;
  /** Tax rate as a FRACTION (0.22 = 22%). Absent = derive from the category —
   *  every row written before régimen rates existed. */
  defaultTaxRate?: number;
  sortOrder: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateClientCatalogItemPayload {
  sku?: string;
  description: string;
  unitPrice: number;
  defaultTaxCategory: string;
  /** Fraction, e.g. 0.022. Null clears it. */
  defaultTaxRate?: number | null;
  sortOrder?: number;
}

export type UpdateClientCatalogItemPayload = Partial<
  Omit<CreateClientCatalogItemPayload, "description" | "sku"> & {
    description?: string;
    /** Omit or pass null to clear the code. */
    sku?: string | null;
  }
>;

export async function listClientCatalogItems(
  clientId: string
): Promise<ClientCatalogItem[]> {
  const { data } = await apiClient.get<{ data: ClientCatalogItem[] }>(
    `/clients/${clientId}/catalog-items`
  );
  return data.data;
}

export async function createClientCatalogItem(
  clientId: string,
  payload: CreateClientCatalogItemPayload
): Promise<ClientCatalogItem> {
  const { data } = await apiClient.post<ClientCatalogItem>(
    `/clients/${clientId}/catalog-items`,
    payload
  );
  return data;
}

export async function updateClientCatalogItem(
  clientId: string,
  itemId: string,
  payload: UpdateClientCatalogItemPayload
): Promise<ClientCatalogItem> {
  const { data } = await apiClient.patch<ClientCatalogItem>(
    `/clients/${clientId}/catalog-items/${itemId}`,
    payload
  );
  return data;
}

export async function deleteClientCatalogItem(
  clientId: string,
  itemId: string
): Promise<void> {
  await apiClient.delete(`/clients/${clientId}/catalog-items/${itemId}`);
}
